import { db } from '../config/firebase';
import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';

class WalletService {
  // Busca o saldo disponível (considerando reservas)
  async getAvailableBalance(userId: string): Promise<number> {
    try {
      const empresaDoc = await getDoc(doc(db, 'Empresa', userId));
      if (empresaDoc.exists()) {
        const data = empresaDoc.data();
        const saldoTotal = data.saldoCarteira || 0;
        const saldoReservado = data.saldoReservado || 0;
        return Math.max(0, saldoTotal - saldoReservado);
      }
      return 0;
    } catch (error) {
      console.error('Erro ao buscar saldo disponível:', error);
      return 0;
    }
  }

  // Busca o saldo total
  async getBalance(userId: string): Promise<number> {
    try {
      const empresaDoc = await getDoc(doc(db, 'Empresa', userId));
      if (empresaDoc.exists()) {
        return empresaDoc.data().saldoCarteira || 0;
      }
      return 0;
    } catch (error) {
      console.error('Erro ao buscar saldo:', error);
      return 0;
    }
  }
}

export const walletService = new WalletService();

